import { RuleNestedArray } from '..'
import { msg } from '../messages'
import { minLength } from './length'

const AT_LEAST_A_LETTER = /^(?=.*[a-zA-Z]).*$/
const AT_LEAST_A_NUMBER = /^(?=.*[0-9]).*$/

export const senha: RuleNestedArray = [
  minLength(6),
  (inputValue: string): string => {
    // Testar se possui ao menos uma letra e um numero
    if (!AT_LEAST_A_LETTER.test(inputValue) || !AT_LEAST_A_NUMBER.test(inputValue)) {
      return msg('senha', inputValue)
    }
    return null
  },
]
